import { create } from 'zustand';

const useJoinDonorCom = create((set) => ({
  isOpen: false,
  duration: null, // store selected plan duration
  open: (duration) => set({ isOpen: true, duration }),
  close: () => set({ isOpen: false, duration: null })
}));

export default useJoinDonorCom;
